/**
 * Normalize a URL into a canonical key for matching the current location
 * against message URLs: origin stripped, percent-encoding decoded. Message
 * URLs arrive percent-encoded from the backend (e.g. the polygons GeoJSON of
 * a shared shape) while window.location may hold either form, so both sides
 * must be normalized before comparing.
 */
// Captured at module load, before the app starts rewriting the URL via
// history.replaceState (map syncs rewrite e.g. the zoom), so matching runs
// against the URL the user actually opened
const initialUrlKey =
  typeof window !== 'undefined'
    ? normalizeUrlKey(window.location.pathname + window.location.search)
    : ''

export function getInitialUrlKey(): string {
  return initialUrlKey
}

export function normalizeUrlKey(url: string): string {
  let pathAndQuery = url
  try {
    const parsed = new URL(url, 'https://libmap.org')
    pathAndQuery = parsed.pathname + parsed.search
  } catch {
    // Not a parseable URL: fall through with the raw string
  }
  try {
    return decodeURIComponent(pathAndQuery)
  } catch {
    // Malformed percent-encoding: use the undecoded form
    return pathAndQuery
  }
}
